import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css'; // Centralized design tokens + shared helpers (additive)
import './index.css';
import FrontApp from "./FrontApp"; // Public site: stays in the main bundle (first paint)
import reportWebVitals from './reportWebVitals';
import { CartProvider } from "./context/CartContext";

// PERFORMANCE: the admin panel (suneditor, recharts, react-icons, data tables…)
// is now its own chunk, downloaded only for /admin — public visitors no longer pay for it.
const App = lazy(() => import('./App'));

const root = ReactDOM.createRoot(document.getElementById('root'));
// /admin = admin panel, /doctoradmin = doctor admin (https://aceveda.com/doctoradmin/)
const isAdmin = ["/admin", "/doctoradmin"].some((p) => window.location.pathname.startsWith(p));

if (isAdmin) {
  root.render(
    <React.StrictMode>
      <Suspense fallback={null}>
        <App />
      </Suspense>
    </React.StrictMode>
  );
} else {
  // index.html starts the public stylesheets at parse time; wait for them (max 3.5s)
  // so the first paint is styled and nothing shifts afterwards.
  // (The old <Preloader/> waited for window.load — i.e. every image — and was removed.)
  (window.__frontCss || Promise.resolve()).then(() => {
    root.render(
      <React.StrictMode>
        <CartProvider>
          <FrontApp />
        </CartProvider>
      </React.StrictMode>
    );
  });
}

reportWebVitals();
